<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs default-active-key="0" @change="handleTabChange">
        <a-tab-pane key="0" tab="代理商"></a-tab-pane>
        <a-tab-pane key="1" tab="分销商"></a-tab-pane>
      </a-tabs>

      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.tenantName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="联系人名称">
                <a-input v-model="queryParam.userName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="联系人电话">
                <a-input v-model="queryParam.userPhone" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :value="0"> 禁用 </a-select-option>
                  <a-select-option :value="1"> 有效 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="advanced">
              <a-form-item label="创建时间">
                <a-range-picker v-model="value" format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime" />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :loading="loading" :size="tableSize" :rowKey="rowKeyMethod" :columns="columns" :data-source="list"
        :pagination="false">
        <span slot="name" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.name">
            <span class="tenant-name">{{ record.name || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="contactInfo" slot-scope="text, record">
          <div>{{ record.contacts || '--' }}</div>
          <div>{{ record.mobile || '--' }}</div>

        </span>
        <span slot="capacityUsage" slot-scope="text, record">
          <div class="capacity-container">
            <div class="capacity-progress">
              <div class="progress-bar"
                :style="{ width: getUsageRate(record) + '%', backgroundColor: getProgressColor(record) }"></div>
            </div>
            <div class="capacity-text">
              {{ $formatCapacity(record.usedCapacity) }}/{{ $formatCapacity(record.totalCapacity) }}
            </div>
          </div>
        </span>
        <span slot="sharedCapacityUsage" slot-scope="text, record">
          <div class="capacity-container">
            <div class="capacity-progress">
              <div class="progress-bar"
                :style="{ width: getSharedUsageRate(record) + '%', backgroundColor: getSharedProgressColor(record) }">
              </div>
            </div>
            <div class="capacity-text">
              {{ $formatCapacity(record.sumUsedCapacity) }}/{{ $formatCapacity(record.sumAllocateCapacity) }}
            </div>
          </div>
        </span>
        <span slot="effectiveTime" slot-scope="text, record">
          <div>生效：{{ formatDateString(record.effectiveTime) }}</div>
          <div>失效：{{ formatDateString(record.expireTime) }}</div>
        </span>
        <span slot="remainingCapacity" slot-scope="text, record">
          <div>{{ $formatCapacity(record.remainingCapacity) }}</div>
        </span>
        <span slot="renewType" slot-scope="text, record">
          <span>{{ record.renewType === 1 ? '安心存储' : record.renewType === 2 ? '灵活存储' : '--' }}</span>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge v-if="record.status === 1" :status="record.status === 1 ? 'success' : 'default'"
            :text="record.status === 1 ? '有效' : '--'" />
          <span v-else>--</span>
        </span>
        <span slot="packageInfo" slot-scope="text, record">
          <div>{{ record.packageId ? `套餐 ${record.packageId}` : '无套餐' }}</div>
          <a-button v-if="!record.packageId && record.renewType === 1 && storageInfo && storageInfo.renewType !== 2"
            type="link" size="small" @click="handleBuyPackage(record)">
            购买套餐
          </a-button>
          <a-button v-if="!record.packageId && (record.renewType === 2 || (storageInfo && storageInfo.renewType === 2))"
            type="link" size="small" @click="handleAllocateCapacity(record)">
            分配容量
          </a-button>
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-if="hasValidId(record)" @click="handleDetail(record)"
            v-hasPermi="['1e63dea4c7366c2ca763666365791ffbq:0:q']">
            详情
          </a>
          <a-divider v-if="hasValidId(record)" type="vertical" />

          <a-dropdown v-hasPermi="['f1cd1866042366980928047f4b501a4dc:0:c', '9ea4ec2db8bbf66a9765f5ea0957e00fc:0:c']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-if="!record.packageId && !(storageInfo && storageInfo.renewType === 2)"
                v-hasPermi="['f1cd1866042366980928047f4b501a4dc:0:c']">
                <a @click="handleBuyPackage(record)"> 购买套餐 </a>
              </a-menu-item>
              <!-- <a-menu-item v-if="(record.renewType === 2 || (storageInfo && storageInfo.renewType === 2))" v-hasPermi="['f1cd1866042366980928047f4b501a4dc:0:c']">
                <a @click="handleAllocateCapacity(record)"> 分配容量 </a>
              </a-menu-item> -->
              <a-menu-item
                v-if="record.renewType === 1 && record.packageId && showRenewButton(record) && !(storageInfo && storageInfo.renewType === 2)"
                v-hasPermi="['f1cd1866042366980928047f4b501a4dc:0:c']">
                <a @click="handleRenewPackage(record)"> 续费套餐 </a>
              </a-menu-item>
              <a-menu-item v-if="hasValidId(record) || storageInfo.renewType === 2"
                v-hasPermi="['9ea4ec2db8bbf66a9765f5ea0957e00fc:0:c']">
                <a @click="handleShareCapacity(record)"> 容量分配 </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
    <createForm ref="vrForm" @getList="getList"></createForm>
    <detail-drawer ref="detailDrawer" />
  </page-header-wrapper>
</template>

<script>
import { fetchList } from '@/api/VR/tenantStorage/index'
import { getStorageInfo } from '@/api/VR/storage'
import createForm from './model/createForm'
import DetailDrawer from './model/DetailDrawer'
import parameter from '@/mixins/parameter'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: 'TenantStorageList',
  components: {
    createForm,
    DetailDrawer,
  },
  mixins: [tableMixin, parameter],

  data() {
    return {
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        renewType: undefined,
        status: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        proxyType: 0,
        userPhone: undefined,
      },
      renewTypeStatus: [
        { id: 1, name: '安心存储' },
        { id: 2, name: '灵活存储' },
      ],
      loading: false,
      list: [],
      total: 0,
      value: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      storageInfo: null,
      columns: [
        {
          title: '单位名称',
          width: '15%',
          // fixed: 'left',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          align: 'center',
          // ellipsis: true,
        },
        {
          title: '联系人信息',
          width: '8%',
          dataIndex: 'contacts',
          scopedSlots: { customRender: 'contactInfo' },
          align: 'center',
        },
        {
          title: '容量使用',
          width: '12%',
          dataIndex: 'usedCapacity',
          scopedSlots: { customRender: 'capacityUsage' },
          align: 'center',
        },
        {
          title: '共享容量',
          width: '12%',
          dataIndex: 'sumAllocateCapacity',
          scopedSlots: { customRender: 'sharedCapacityUsage' },
          align: 'center',
        },
        {
          title: '有效期',
          width: '8%',
          dataIndex: 'effectiveTime',
          scopedSlots: { customRender: 'effectiveTime' },
          align: 'center',
        },
        {
          title: '存储类型',
          width: '8%',
          dataIndex: 'renewType',
          scopedSlots: { customRender: 'renewType' },
          align: 'center',
        },
        {
          title: '状态',
          width: '8%',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: '剩余容量',
          width: '8%',

          dataIndex: 'remainingCapacity',
          scopedSlots: { customRender: 'remainingCapacity' },
          align: 'center',
        },
        {
          title: '套餐信息',
          width: '8%',
          dataIndex: 'packageInfo',
          scopedSlots: { customRender: 'packageInfo' },
          align: 'center',
        },
        {
          title: '操作',
          width: '8%',
          // fixed: 'right',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
    }
  },

  created() {
    this.getStorageInfo()
  },

  methods: {
    handleTabChange(key) {
      this.queryParam.proxyType = parseInt(key)
      this.queryParam.pageNum = 1
      this.getList()
    },

    rowKeyMethod(record) {
      if (record && record.id) {
        return record.id
      }
      return `row-${this.list.indexOf(record)}`
    },

    hasValidId(record) {
      return record && record.id && String(record.id).trim() !== ''
    },

    getStorageInfo() {
      getStorageInfo().then(response => {
        this.storageInfo = response.data[0]
      }).catch(error => {
        console.error('获取存储信息失败:', error)
      })
    },

    formatDateString(dateString) {
      if (!dateString || dateString === '--') {
        return '--'
      }
      try {
        return moment(dateString).format('YYYY-MM-DD')
      } catch (error) {
        console.error('格式化日期出错:', error)
        return dateString
      }
    },

    showRenewButton(record) {
      if (!record.expireTime) {
        return false
      }

      try {
        const expireDate = moment(record.expireTime)
        const currentDate = moment()
        const threeMonthsLater = moment().add(3, 'months')

        return expireDate.isBetween(currentDate, threeMonthsLater, null, '[]')
      } catch (error) {
        console.error('计算续费时间出错:', error)
        return false
      }
    },

    getList() {
      this.loading = true
      fetchList(this.queryParam)
        .then((res) => {
          this.loading = false
          if (res.success && res.data) {
            this.list = this.cleanDataList(res.data.records || [])
            this.total = res.data.total || 0
          } else {
            this.list = []
            this.total = 0
          }
        })
        .catch(() => {
          this.loading = false
          this.list = []
          this.total = 0
        })
    },

    cleanDataList(list) {
      return list.map((item) => {
        const cleaned = { ...item }
        const fields = ['name', 'contacts', 'mobile', 'effectiveTime', 'expireTime']
        fields.forEach((field) => {
          if (cleaned[field] === null) {
            cleaned[field] = '--'
          }
        })
        return cleaned
      })
    },

    handleDetail(record) {
      if (!this.hasValidId(record)) {
        this.$message.warning('当前记录无法查看详情')
        return
      }
      this.$refs.detailDrawer.show(record)
    },

    getUsageRate(record) {
      if (!record.totalCapacity || record.totalCapacity === 0) return 0
      const rate = ((record.usedCapacity || 0) / record.totalCapacity) * 100
      return Math.min(100, Math.max(0, rate.toFixed(1)))
    },

    getProgressColor(record) {
      const rate = this.getUsageRate(record)
      if (rate >= 90) return '#ff4d4f'
      if (rate >= 70) return '#faad14'
      return '#52c41a'
    },

    getSharedUsageRate(record) {
      if (!record.sumAllocateCapacity || record.sumAllocateCapacity === 0) return 0
      const rate = ((record.sumUsedCapacity || 0) / record.sumAllocateCapacity) * 100
      return Math.min(100, Math.max(0, rate.toFixed(1)))
    },

    getSharedProgressColor(record) {
      const rate = this.getSharedUsageRate(record)
      if (rate >= 90) return '#ff4d4f'
      if (rate >= 70) return '#faad14'
      return '#52c41a'
    },

    handleBuyPackage(record) {
      const query = {
        type: 1,
        tenantId: record.tenantId || '',
      }

      this.$router.push({
        name: 'BuyNow',
        query: query,
      })
    },

    handleAllocateCapacity(record) {
      const query = {
        type: record.renewType,
        tenantId: record.tenantId || '',
      }

      this.$router.push({
        name: 'BuyNow',
        query: query,
      })
    },

    handleRenewPackage(record) {
      const query = {
        type: record.renewType,
        tenantId: record.tenantId || '',
        id: record.packageId || '',
        from: 'tenant', // 添加来源标识
      }

      this.$router.push({
        name: 'BuyNow',
        query: query,
      })
    },

    handleShareCapacity(record) {
      const query = {
        tenantId: record.tenantId,
        tenantName: record.name,
        storagePoolId: '',
      }

      this.$router.push({
        name: 'TrafficAllocation',
        query: query,
      })
    },

    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },

    onChangeTime(e) {
      if (e && e.length === 2) {
        this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    resetQuery() {
      this.value = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        renewType: undefined,
        status: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        proxyType: this.queryParam.proxyType,
        userPhone: undefined,
      }
      this.getList()
    },

    onShowSizeChange(current, pageSize) {
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    handleExport() {
      const that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'vr/storage/tenant/export',
            {
              ...that.queryParam,
            },
            `tenant_storage_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
  },

  mounted() {
    this.getList()
  },
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.ant-table-pagination {
  margin-top: 16px;
  text-align: right;
}

.capacity-container {
  width: 100%;
}

.capacity-progress {
  width: 100%;
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 4px;
}

.progress-bar {
  height: 100%;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.capacity-text {
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}

.tenant-name {
  display: inline-block;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

/* 优化表格响应式布局 */
.table-container {
  width: 100%;
  overflow-x: auto;
}

/* 确保表格充分利用空间 */
.ant-table-wrapper {
  width: 100%;
}

.ant-table {
  min-width: 100%;
}

/* 优化列宽自适应 */
.ant-table-thead>tr>th,
.ant-table-tbody>tr>td {
  padding: 8px 12px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .ant-table-wrapper {
    overflow-x: auto;
  }

  .ant-table {
    min-width: 1000px;
  }

  .tenant-name {
    max-width: 120px;
  }
}

/* 中等屏幕适配 */
@media screen and (min-width: 769px) and (max-width: 1200px) {
  .ant-table {
    min-width: 1200px;
  }
}
</style>
